import React, { useEffect } from "react";
import "./style.scss";
import "../../../style/feature.scss";
import "../../../style/typography.scss";
import "../../../style/block.scss";
import "../../../style/buttons.scss";
import "../../../style/forms.scss";
import "../../../style/alerts.scss";
import { useNavigate } from "react-router";
import { LOGIN_PAGE } from "../../routes";
import { SubmitHandler, useForm } from "react-hook-form";
import { emailValidator } from "../../../utils/formsValidation";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import { REMIND_PASSWORD_USER_URL } from "../../api/apiRoutes";
import { useDispatch, useSelector } from "react-redux";
import { clearErrors, setSuccessMessage } from "../../store/alerts/alertsActions";
import useFacility from "../../../utils/hooks/useFacility";
import { State } from "../../store";
import { useTranslation } from "react-i18next";
import EAButton from "../shared/Buttons/EAButton";
import { IoMdArrowRoundForward } from "react-icons/io";
import EATextField from "../shared/TextField/EATextField";
import EADivider from "../shared/EADivider";

type Inputs = {
  email: string;
};

const RemindPass: React.FC = () => {
  const navigate = useNavigate();
  const { post } = useApiRequest();
  const facilityIds = useFacility();
  const dispatch = useDispatch();
  const alertLogin = useSelector((state: State) => state.alerts.errors);
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();
  const handleRemindPass: SubmitHandler<Inputs> = async (data) => {
    const { isError } = await post(REMIND_PASSWORD_USER_URL(facilityIds), { email: data.email });
    if (!isError) {
      dispatch(setSuccessMessage(t("haslo_zostalo_wyslane_na_podany_adres_email")));
    }
  };

  useEffect(() => {
    dispatch(clearErrors());
    //eslint-disable-next-line
  }, []);

  return (
    <div className="auth-page flex-center-center">
      <div className="auth-box shadow">
        <form onSubmit={handleSubmit(handleRemindPass)}>
          <h1>{t("zapomnialem_hasla")}</h1>
          <p>{t("podaj_adres_email_podany_przy_rejestracji_na_ktory_zostanie_przeslane_nowe_haslo")}</p>

          <EATextField
            label={"E-mail"}
            type="email"
            name="email"
            placeholder={"E-mail"}
            register={{ ...register("email", { ...emailValidator(true) }) }}
            fullWidth
            error={Boolean(errors.email)}
          />

          {alertLogin && alertLogin.length > 0 && <div className="alert alert-red">{alertLogin}</div>}

          <EADivider />

          <div className="flex-between-center buttons">
            <EAButton title={t("zaloguj_sie")} onClick={() => navigate(LOGIN_PAGE)} fullWidth variant="outlined" />
            <EAButton title={t("resetuj_haslo")} inputType="submit" endIcon={<IoMdArrowRoundForward />} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default RemindPass;
